import {Pipe, PipeTransform} from '@angular/core';
import {ShuntPriority} from "@services";

@Pipe({
    name: 'shuntPriority',
    standalone: true
})
export class ShuntPriorityPipe implements PipeTransform {
    transform(value: ShuntPriority | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case ShuntPriority.High: return "1";
            case ShuntPriority.Medium: return "2";
            case ShuntPriority.Low: return "3";
            default: return value;
        }
    }
}